import { Link, NavLink, Outlet } from "react-router-dom";
import {
  Home, UserCircle, BookOpen, Calendar, Users, LogOut, Send, Sparkles, Eye, Church, LibraryBig, HeartHandshake,
} from "lucide-react";
import { useMemberAuth } from "./MemberAuthContext";
import { LOGO_URL } from "../assets/images";

export default function MemberLayout() {
  const { member, logout } = useMemberAuth();
  const isAssessor = member?.ciees_role === "assessor_espiritual";

  const links = [
    { to: "/membros", end: true, icon: Home, label: "Início" },
    { to: "/membros/perfil", icon: UserCircle, label: "Perfil" },
    { to: "/membros/horario-espiritual", icon: Sparkles, label: "Horário Espiritual" },
    { to: "/membros/santuarios", icon: Church, label: "Santuários" },
    { to: "/membros/capital-de-gracas", icon: HeartHandshake, label: "Capital de Graças" },
    ...(isAssessor ? [{ to: "/membros/acompanhamento", icon: Eye, label: "Acompanhamento" }] : []),
    { to: "/membros/convites", icon: Send, label: "Convidar" },
    { to: "/membros/diretorio", icon: Users, label: "Diretório" },
    { to: "/membros/percursos", icon: BookOpen, label: "Percursos" },
    { to: "/membros/biblioteca", icon: LibraryBig, label: "Biblioteca" },
    { to: "/membros/retiros", icon: Calendar, label: "Retiros e eventos" },
  ];

  return (
    <div className="min-h-screen bg-[hsl(var(--background))]" data-testid="member-layout">
      {/* Top bar */}
      <header className="bg-white border-b border-[hsl(var(--border))]">
        <div className="container-page flex items-center justify-between h-16">
          <Link to="/membros" className="flex items-center gap-3">
            <img src={LOGO_URL} alt="CIEES" className="h-10 w-10" />
            <div>
              <div className="display-heading text-base text-[hsl(var(--primary))]">CIEES</div>
              <div className="text-[9px] tracking-[0.28em] uppercase text-[hsl(var(--muted-foreground))]">Área de Sócios</div>
            </div>
          </Link>
          <div className="flex items-center gap-4">
            <div className="hidden sm:flex items-center gap-3 text-sm">
              {member?.picture ? (
                <img src={member.picture} alt={member.name} className="h-8 w-8 rounded-full" />
              ) : (
                <div className="h-8 w-8 rounded-full bg-[hsl(var(--secondary))] flex items-center justify-center text-xs font-medium">
                  {(member?.name || "?").slice(0, 1).toUpperCase()}
                </div>
              )}
              <div>
                <div className="text-xs font-medium">{member?.name}</div>
                <div className="text-[10px] text-[hsl(var(--muted-foreground))]">{member?.email}</div>
              </div>
            </div>
            <button onClick={logout} className="inline-flex items-center gap-1.5 text-xs uppercase tracking-[0.18em] text-[hsl(var(--muted-foreground))] hover:text-[hsl(var(--primary))]" data-testid="member-logout">
              <LogOut className="h-3.5 w-3.5" /> Sair
            </button>
          </div>
        </div>
        {/* Tabs */}
        <nav className="container-page flex items-center gap-1 overflow-x-auto border-t border-[hsl(var(--border))]">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.end}
              className={({ isActive }) =>
                `inline-flex items-center gap-2 px-4 py-3 text-xs uppercase tracking-[0.16em] border-b-2 transition-colors whitespace-nowrap ${
                  isActive
                    ? "border-[hsl(var(--primary))] text-[hsl(var(--primary))] font-medium"
                    : "border-transparent text-[hsl(var(--muted-foreground))] hover:text-[hsl(var(--foreground))]"
                }`
              }
              data-testid={`member-nav-${l.to.replace(/\//g, "-")}`}
            >
              <l.icon className="h-3.5 w-3.5" /> {l.label}
            </NavLink>
          ))}
        </nav>
      </header>

      <main>
        <Outlet />
      </main>
    </div>
  );
}
